$(() => {
  let textarea = $('#js-forced-modal-body-input')
  let iframe = $('#js-forced-modal-body-preview-iframe')
  if (!textarea.length || !iframe.length) {
    return
  }

  $('a[href="#js-forced-modal-body-preview"]').on('shown.bs.tab', () => {
    iframe.attr('srcdoc', '<div style="font-size: 14px; padding: 2rem;">' + textarea.val() + '</div>')
  })
})
